import * as defaultQueries from "./defaultQueries";
import * as mutations from "./mutations";
import * as queries from "./queries";
import * as fragments from "./fragments";

export { defaultQueries, mutations, queries, fragments };
